import { AppBar, Button, IconButton, Toolbar, Typography } from '@material-ui/core';
import MenuIcon from '@material-ui/icons/Menu';
import { UserIcon } from 'components/Icons';
import LayoutContext from 'components/Layout/LayoutContext';
import CustomRouterLink from 'components/CustomRouterLink/CustomRouterLink';
import { AssociadoRoutePath, AssessorRoutePath } from 'library/Routes';
import React, { useCallback, useContext, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { IReducer } from 'store/Reducer';
import { leftMenuActionsOpen } from '../../store/modules/LeftMenuActions';
import SicrediLogo from '../SicrediLogo/SicrediLogo';
import UserMenu from '../UserMenu/UserMenu';
import useStyles from './style';
import TopBarMenus from './TopBarMenus';
import { isAssociadoProfile } from 'utils/AuthUtils';

interface Props {
  readOnly?: boolean;
  mostrarSaudacao?: boolean;
  disableLeftMenu?: boolean;
}

export default ({ readOnly, mostrarSaudacao, disableLeftMenu }: Props) => {
  const { t } = useTranslation();
  const history = useHistory();
  const dispatch = useDispatch();
  const layoutContext = useContext(LayoutContext);
  const [anchorOFUserMenu, setAnchorOFUserMenu] = useState<Element | undefined>();
  const { usuario, logged } = useSelector((state: IReducer) => state.auth);
  const classes = useStyles();

  const userName = useMemo(() => {
    if (logged && usuario) {
      return usuario.nome.split(' ')[0];
    }
    return null;
  }, [usuario, logged]);

  const openLeftMenu = useCallback(() => {
    dispatch(leftMenuActionsOpen());
  }, [dispatch]);

  const openUserMenu = useCallback(
    (event: React.MouseEvent<HTMLElement>) => {
      setAnchorOFUserMenu(event.currentTarget);
    },
    [setAnchorOFUserMenu]
  );

  const closeUserMenu = useCallback(() => {
    setAnchorOFUserMenu(undefined);
  }, [setAnchorOFUserMenu]);

  const onClickRightButton = useCallback(
    (event: React.MouseEvent<HTMLElement>) => {
      if (logged && usuario) {
        openUserMenu(event);
      } else {
        history.push(AssociadoRoutePath);
      }
    },
    [usuario, logged, openUserMenu, history]
  );

  return (
    <>
      <AppBar
        className={[classes.wrapper, layoutContext.pageMenuItems.length > 0 ? classes.lightShadowWrapper : ''].join(
          ' '
        )}
        position="fixed"
      >
        <Toolbar className={classes.bar}>
          {!readOnly && !disableLeftMenu && logged && usuario ? (
            <IconButton edge="start" color="inherit" aria-label="menu" onClick={() => openLeftMenu()}>
              <MenuIcon />
            </IconButton>
          ) : null}
          {usuario?.perfil && (
            <CustomRouterLink
              className={classes.logoButton}
              to={isAssociadoProfile(usuario.perfil) ? AssociadoRoutePath : AssessorRoutePath}
            >
              <SicrediLogo />
            </CustomRouterLink>
          )}
          <div style={{ flex: 1 }}></div>
          {!readOnly && userName && mostrarSaudacao ? (
            <Typography color="primary" className={classes.saudacao}>
              {t('TopBar.saudacao', { nome: userName })}
            </Typography>
          ) : null}
          {!readOnly ? (
            logged && usuario ? (
              <IconButton
                className={classes.userMenuButton}
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                onClick={onClickRightButton}
                color="inherit"
              >
                <UserIcon />
              </IconButton>
            ) : (
              <Button
                variant="text"
                endIcon={<UserIcon />}
                className={classes.loginButton}
                onClick={onClickRightButton}
              >
                {t('LoginAssociado.botao')}
              </Button>
            )
          ) : null}
          <UserMenu mostrarSaudacao={!mostrarSaudacao} anchorEl={anchorOFUserMenu || null} onClose={closeUserMenu} />
        </Toolbar>
      </AppBar>
      <Toolbar className={classes.bar} />
      <TopBarMenus menuItems={layoutContext.pageMenuItems} />
    </>
  );
};
